<!-- <p>add-virtual-sensor works!</p> -->
<app-dialog-header headerIcon="mediation" headerText="Add Virtual DataPoint"
    (onCloseClick)="onCancelClick()"></app-dialog-header>
<div class="dialog">
    <div class="list-container">
        <ejs-listview [dataSource]='virtualSensors' cssClass="e-list-template">
        <ng-template #template let-dataSource>
            <div class="ejs-listview-item virtual-sensor-item">
                <span>{{dataSource.VirtualSensorName}}</span>
                <div class="input-dps">
                    <span *ngFor="let dp of dataSource._dataPoints">{{dp.value}}: {{dp.datapoint.DPTitle}}</span>
                </div>
                <span>{{dataSource.Conversion}}</span>
                <mat-checkbox color="primary" [checked]="dataSource._selected" (change)="selectVirtualSensor($event, dataSource)"></mat-checkbox>
            </div>
        </ng-template>
    </ejs-listview>
    </div>
    <div mat-dialog-actions>
        <button mat-button [mat-dialog-close]="assetVirtualSensors">Ok</button>
        <button mat-button (click)="onCancelClick()" cdkFocusInitial>Cancel</button>
    </div>
</div>